<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Resumo da Classificação" variant="responsive-xs">
    <app-back-button (back)="voltar()"></app-back-button>
  </app-page-header>

  <mat-card *ngIf="retificado" class="card-warning" style="margin-bottom: 16px;">
    <span>⚠️ A classificação gerada pelo sistema foi retificada pela unidade em decorrência de recurso deferido. Consultar os andamentos do concurso para o resultado definitivo.</span>
  </mat-card>

  <div class="tables-container">
    <div class="scores-by-type">
      <div class="title">
        <mat-icon>assessment</mat-icon>
        <span>Resultados por prova</span>
      </div>
      
      <div *ngIf="tiposProva.length === 0" class="no-data-message">
        <p>Ainda não há notas de prova a serem exibidas.</p>
      </div>
      
      <div *ngIf="tiposProva.length > 0" class="exam-type-buttons">
        <button 
          *ngFor="let tipo of tiposProva" 
          mat-raised-button 
          [color]="tipoProvaSelecionado === tipo ? 'primary' : ''"
          (click)="selecionarTipoProva(tipo)"
          class="mr-8 mb-8">
          {{ tipo }}
        </button>
      </div>

      <div *ngIf="tipoProvaSelecionado" class="scores-type-table">
        <table mat-table [dataSource]="notasPorTipo[tipoProvaSelecionado]" class="mat-elevation-z8">
          <ng-container matColumnDef="inscricaoId">
            <th mat-header-cell *matHeaderCellDef>Inscrição</th>
            <td mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
          </ng-container>

          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
            <td mat-cell *matCellDef="let row">
              <strong>{{ row.nomeSocial || row.nome }}</strong><br />
              <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
            </td>
          </ng-container>

          <ng-container *ngFor="let coluna of colunasPorTipo[tipoProvaSelecionado]">
            <ng-container *ngIf="coluna !== 'nome' && coluna !== 'inscricaoId'" [matColumnDef]="coluna">
              <th mat-header-cell *matHeaderCellDef [matTooltip]="getComissaoMatricula(coluna) ? 'Matrícula: ' + getComissaoMatricula(coluna) : 'Externo Unicamp'">Prof.(a) Dr.(a) {{ getComissaoNome(coluna) }}</th>
              <td mat-cell *matCellDef="let row">{{ row[coluna] }}</td>
            </ng-container>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="colunasPorTipo[tipoProvaSelecionado]"></tr>
          <tr mat-row *matRowDef="let row; columns: colunasPorTipo[tipoProvaSelecionado]"></tr>
        </table>
      </div>
    </div>

    <div class="notes-block">
      <div class="title">
        <mat-icon>emoji_events</mat-icon>
        <span>Classificação Final - Fase 2</span>
      </div>
      
      <div *ngIf="!dataSourceFase2 || !dataSourceFase2.data || dataSourceFase2.data.length === 0" class="no-data-message">
        <p>Ainda não há dados da Fase 2 disponíveis.</p>
      </div>
      
      <table *ngIf="dataSourceFase2 && dataSourceFase2.data && dataSourceFase2.data.length > 0" mat-table [dataSource]="dataSourceFase2" class="mat-elevation-z8">
        <ng-container matColumnDef="classificacao">
          <th class="col-classification" mat-header-cell *matHeaderCellDef>Classificação</th>
          <td class="col-classification" mat-cell *matCellDef="let row">
            <mat-icon *ngIf="row.estaEliminado" class="eliminated-icon" matTooltip="Não Habilitado">close</mat-icon>
            <span *ngIf="!row.estaEliminado">{{ row.classificacao }}º</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="inscricaoId">
          <th class="col-registration" mat-header-cell *matHeaderCellDef>Inscrição</th>
          <td class="col-registration" mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th class="col-name" mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
          <td class="col-name" mat-cell *matCellDef="let row">
            <strong>{{ row.nomeSocial || row.nome }}</strong>
            <mat-icon *ngIf="row.jurado" class="jury-icon" matTooltip="Jurado">gavel</mat-icon>
            <img *ngIf="row.PCD && exibirIconePCD()" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
            <br />
            <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nascimento">
          <th class="col-birthdate" mat-header-cell *matHeaderCellDef>Nascimento</th>
          <td class="col-birthdate" mat-cell *matCellDef="let row">{{ row.nascimento }}</td>
        </ng-container>

        <ng-container matColumnDef="conceito">
          <th class="col-grade" mat-header-cell *matHeaderCellDef>Conceito</th>
          <td class="col-grade" mat-cell *matCellDef="let row">
            <div *ngIf="row.conceito" style="display: inline-flex; align-items: center; gap: 2px; vertical-align: middle;">
              <span>{{ row.conceito }}</span>
              <mat-icon
                *ngIf="row.justificativa"
                class="justificativa-icon"
                color="primary"
                (click)="mostrarJustificativa(row.justificativa)"
                matTooltip="Ver justificativa de desempate">description</mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="indicacoes">
          <th class="col-nominations" mat-header-cell *matHeaderCellDef>Indicações</th>
          <td class="col-nominations" mat-cell *matCellDef="let row">{{ row.posicaoMaisRecorrente }}º: {{row.quantidadeNaPosicaoMaisRecorrente}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasGrid;"></tr>
      </table>
    </div>

    <div class="classification-block">
      <div class="title">
        <mat-icon>people</mat-icon>
        <span>Classificação por Examinador - Fase 2</span>
      </div>
      
      <div *ngIf="!dataSourceClassificacaoFase2 || !dataSourceClassificacaoFase2.data || dataSourceClassificacaoFase2.data.length === 0" class="no-data-message">
        <p>Ainda não há dados da Fase 2 disponíveis.</p>
      </div>
      
      <table *ngIf="dataSourceClassificacaoFase2 && dataSourceClassificacaoFase2.data && dataSourceClassificacaoFase2.data.length > 0" mat-table [dataSource]="dataSourceClassificacaoFase2" class="full-width-table">
        <ng-container matColumnDef="posicao">
          <th class="col-classification" mat-header-cell *matHeaderCellDef>Classificação</th>
          <td class="col-classification" mat-cell *matCellDef="let linha">{{linha.posicao}}º</td>
        </ng-container>
        
        <ng-container *ngFor="let coluna of colunasClassificacaoGrid">
          <ng-container *ngIf="coluna !== 'posicao'">
            <ng-container [matColumnDef]="coluna + '_nome'">
              <th mat-header-cell *matHeaderCellDef colspan="1" [matTooltip]="'Matrícula: ' + getExaminadorMatricula(coluna, 'fase2')">Prof.(a) Dr.(a) {{getExaminadorDisplayName(coluna, 'fase2')}}</th>
              <td mat-cell *matCellDef="let linha">
                <strong>{{ linha[coluna + '_nome'] }}</strong><br />
                <span *ngIf="linha[coluna + '_nomeSocial']" class="nome-social">/ {{ linha[coluna + '_nomeSocial'] }}</span>
              </td>
            </ng-container>
            <ng-container [matColumnDef]="coluna + '_media'">
              <th mat-header-cell *matHeaderCellDef colspan="1">Média</th>
              <td mat-cell *matCellDef="let linha">{{linha[coluna + '_media'] || '-'}}</td>
            </ng-container>
            <ng-container [matColumnDef]="coluna + '_conceito'">
              <th mat-header-cell *matHeaderCellDef colspan="1">Conceito</th>
              <td mat-cell *matCellDef="let linha">
                <div *ngIf="linha[coluna + '_conceito']" style="display: inline-flex; align-items: center; gap: 2px; vertical-align: middle;">
                  <span>{{ linha[coluna + '_conceito'] }}</span>
                  <mat-icon
                    *ngIf="linha[coluna + '_justificativa']"
                    class="justificativa-icon"
                    color="primary"
                    (click)="mostrarJustificativa(linha[coluna + '_justificativa'])"
                    matTooltip="Ver justificativa de desempate">description</mat-icon>
                </div>
              </td>
            </ng-container>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="headerRowFase2"></tr>
        <tr mat-row *matRowDef="let row; columns: headerRowFase2;"></tr>
      </table>
    </div>

    <div class="first-phase-block">
      <div class="title">
        <mat-icon>looks_one</mat-icon>
        <span>Resultados da Primeira Fase</span>
      </div>
      
      <div *ngIf="!dataSourceFase1 || !dataSourceFase1.data || dataSourceFase1.data.length === 0" class="no-data-message">
        <p>Ainda não há dados da Fase 1 disponíveis.</p>
      </div>
      
      <table *ngIf="dataSourceFase1 && dataSourceFase1.data && dataSourceFase1.data.length > 0" mat-table [dataSource]="dataSourceFase1" class="mat-elevation-z8">
        <ng-container matColumnDef="classificacao">
          <th class="col-classification" mat-header-cell *matHeaderCellDef>Classificação</th>
          <td class="col-classification" mat-cell *matCellDef="let row">
            <mat-icon *ngIf="row.estaEliminado" class="eliminated-icon" matTooltip="Não Habilitado">close</mat-icon>
            <span *ngIf="!row.estaEliminado">{{ row.classificacao }}º</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="inscricaoId">
          <th class="col-registration" mat-header-cell *matHeaderCellDef>Inscrição</th>
          <td class="col-registration" mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th class="col-name" mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
          <td class="col-name" mat-cell *matCellDef="let row">
            <strong>{{ row.nomeSocial || row.nome }}</strong>
            <img *ngIf="row.PCD && exibirIconePCD()" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
            <br />
            <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nascimento">
          <th class="col-birthdate" mat-header-cell *matHeaderCellDef>Nascimento</th>
          <td class="col-birthdate" mat-cell *matCellDef="let row">{{ row.nascimento }}</td>
        </ng-container>

        <ng-container matColumnDef="mediaFinal">
          <th class="col-averageFinal" mat-header-cell *matHeaderCellDef>Média Final</th>
          <td class="col-averageFinal" mat-cell *matCellDef="let row">{{ row.mediaFinal | number:'1.2-2' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasFase1Grid"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasFase1Grid;"></tr>
      </table>
    </div>

    <div *ngIf="reportesVisiveis.length > 0" class="reportes-block">
      <div class="title">
        <mat-icon>warning</mat-icon>
        <span>Reportes de Identificação na Prova Escrita</span>
      </div>

      <div *ngFor="let reporte of reportesVisiveis; let i = index" class="reporte-resumo-item">
        <div class="reporte-header">
          <span class="reporte-numero">#{{ i + 1 }}</span>
          <span class="reporte-resumo-badge" [ngClass]="reporte.status === 'PENDENTE' ? 'badge-pendente' : reporte.status === 'DEFERIDA' ? 'badge-deferida' : 'badge-indeferida'">
            {{ reporte.status === 'PENDENTE' ? 'Pendente' : reporte.status === 'DEFERIDA' ? 'Deferida' : 'Indeferida' }}
          </span>
        </div>
        <div class="reporte-resumo-grid">
          <div class="reporte-field">
            <span class="field-label">Reportado por:</span>
            <span>{{ reporte.nomeReportador || reporte.reportadoPor }}</span>
          </div>
          <div class="reporte-field">
            <span class="field-label">Data:</span>
            <span>{{ reporte.reportadoEm | date : 'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>
        <div *ngIf="reporte.justificativaReporte" class="reporte-field">
          <span class="field-label">Motivo da suspeita:</span>
          <span class="field-value-scroll">{{ reporte.justificativaReporte }}</span>
        </div>
        <div *ngIf="reporte.decididoPor" class="reporte-decisao-section">
          <div class="reporte-resumo-grid">
            <div class="reporte-field">
              <span class="field-label">Decidido por:</span>
              <span>{{ reporte.nomeDecididor || reporte.decididoPor }}</span>
            </div>
            <div class="reporte-field">
              <span class="field-label">Data da decisão:</span>
              <span>{{ reporte.decididoEm | date : 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
          <div *ngIf="reporte.justificativaDecisao" class="reporte-field">
            <span class="field-label">Justificativa:</span>
            <span class="field-value-scroll">{{ reporte.justificativaDecisao }}</span>
          </div>
        </div>
      </div>
    </div>  </div>
</div>
